/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkerStatusDto
 */
export interface WorkerStatusDto {
    /**
     * Indicates if the worker can be reached.
     * @type {boolean}
     * @memberof WorkerStatusDto
     */
    isReady: boolean;
    /**
     * The timestamp when the worker has been started.
     * @type {string}
     * @memberof WorkerStatusDto
     */
    startedAt: string | null;
    /**
     * The resource types that the worker provides.
     * @type {Array<string>}
     * @memberof WorkerStatusDto
     */
    resourceTypes: Array<string>;
    /**
     * The reason why the worker could not be reached.
     * @type {string}
     * @memberof WorkerStatusDto
     */
    error: string | null;
}

/**
 * Check if a given object implements the WorkerStatusDto interface.
 */
export function instanceOfWorkerStatusDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isReady" in value;
    isInstance = isInstance && "startedAt" in value;
    isInstance = isInstance && "resourceTypes" in value;
    isInstance = isInstance && "error" in value;

    return isInstance;
}

export function WorkerStatusDtoFromJSON(json: any): WorkerStatusDto {
    return WorkerStatusDtoFromJSONTyped(json, false);
}

export function WorkerStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkerStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isReady': json['isReady'],
        'startedAt': json['startedAt'],
        'resourceTypes': json['resourceTypes'],
        'error': json['error'],
    };
}

export function WorkerStatusDtoToJSON(value?: WorkerStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isReady': value.isReady,
        'startedAt': value.startedAt,
        'resourceTypes': value.resourceTypes,
        'error': value.error,
    };
}

